/* eslint-disable max-len */
import React, { useState, useEffect, useContext } from 'react';
import {
  withRouter, Switch, Route, Redirect,
} from 'react-router-dom';
import _ from 'lodash';
import GenericListPair from 'modules/common/components/GenericListPair';
import useDebounce from 'modules/common/components/UseDebounce';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import BusinessTaxContent from './BusinessTaxContent';
import * as actions from '../action';
import * as c from '../constant';

const form = {
  keyword: '',
};

function BusinessTaxContainer({
  match,
  history,
  getBusinessList,
  businessList,
  businessListPager,
  isLoading,
  getLineBusinessList,
  getFixTaxList,
  getOtherFeeList,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(form);

  const UpdateDataOnce = () => {
    getFixTaxList();
    getOtherFeeList();
  };

  const UpdateData = () => {
    getBusinessList();
    getLineBusinessList();
    return () => {
      setModal({ isOpen: false });
    };
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // const renderContent = () => (
  //   <React.Fragment>
  //     <Switch>
  //       <Route
  //         path={`${match.path}/:business_Id?`}
  //         render={() => <BusinessTaxContent UpdateData={UpdateData} />}
  //       />
  //     </Switch>
  //     <Route
  //       path={`${match.path}/:business_Id?`}
  //       render={({ match: { params } }) => (
  //         !params.business_Id && businessList.length > 0 ? (
  //           <Redirect to={`${match.url}/${_.get(businessList, '0.id')}`} />
  //         ) : null)
  //       }
  //     />
  //   </React.Fragment>
  // );

  // const nonRejectedBusinessList = businessList.filter(item => _.get(item, 'included.transactionHistories.0.attributes.transaction_status') !== 'REJECT');
  useEffect(() => {
    UpdateDataOnce();
    UpdateData();
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getBusinessList({ q: formData.keyword });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:business_Id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            getData={getBusinessList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search Business..."
            pathName={`${match.path}/:business_Id?`}
            listName="Business"
            label="Businesses"
            renderItem={item => (
              <div className="p-3">
                <div className="transaction-list-company">{_.get(item, 'attributes.business_name')}</div>
                <h4 className="mt-1 mb-0 transaction-list-name"> {_.get(item, 'attributes.business_owner_name')} </h4>
              </div>
            )}
            isLoading={isLoading}
            selected={params.business_Id}
            data={businessList}
            dataPager={businessListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:business_Id?`}
                    render={() => <BusinessTaxContent UpdateData={UpdateData} />}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:business_Id?`}
                  render={() => (!params.business_Id && businessList.length > 0 ? (
                    <Redirect to={`${match.url}/${_.get(businessList, '0.id')}`} />
                  ) : null)
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

BusinessTaxContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,

  getFixTaxList: PropTypes.instanceOf(Function).isRequired,
  getOtherFeeList: PropTypes.instanceOf(Function).isRequired,

  getBusinessList: PropTypes.instanceOf(Function).isRequired,
  businessList: PropTypes.instanceOf(Object).isRequired,
  businessListPager: PropTypes.instanceOf(Object).isRequired,

  getLineBusinessList: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  businessList: _.get(api, `${c.GET_BUSINESS_LIST}.list`) || [],
  businessListPager: _.get(api, `${c.GET_BUSINESS_LIST}.pager`) || {},
  isLoading: api.loading.indexOf(c.GET_BUSINESS_LIST) > -1,
});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    actions,
  ),
]);

export default enhance(BusinessTaxContainer);
